import React, { useEffect, useState } from 'react';
import { Dispatch } from "redux";
import { useDispatch } from 'react-redux';
import { DatePicker, Checkbox } from 'antd';
import { ArrowDown, DateIcon } from '../Icon';
import { getPaymentsStartAndEndDate } from '../../store/payments';
import { getUsersStartAndEndDate } from '../../store/users/UsersServices';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const { RangePicker } = DatePicker;

const DateRangePicker = ({ checkbox, setCheckbox }: any) => {
  const [date, setDate] = useState<any>({});
  const [open, setOpen] = useState<boolean>(false);
  const [close, setClose] = useState<boolean>(false);
  const dispatch: Dispatch<any> = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname === '/users') {
      if (date.startDate != '' && date.endDate != '') {
        dispatch(getUsersStartAndEndDate(date));
      }
    } else {
      dispatch(getPaymentsStartAndEndDate(date));
    }
  }, [dispatch, date, history]);

  const startInput: any = document.querySelector('.ant-picker-input input');
  const startInputs: any = document.querySelectorAll('.ant-picker-input');

  useEffect(() => {
    if (checkbox[1]) {
      setOpen(false);
      setDate({});

    }
    if (checkbox[0] && (date.endDate != '' || date.startData != '')) {
      if (startInput.value?.length > 0) {
        setOpen(false);

      }
      else {

        setOpen(true);

        startInput.focus()
      }

    }

  }, [checkbox]);
  const handleFocus = () => {

    if (!checkbox[0]) {
      setCheckbox([true, false]);
    }
    if (close) {

      setOpen(true);
    }

    if (startInputs[1]?.className.includes('active') && Object.keys(date).length == 0) {

      setCheckbox([true, false]);
    }


    setClose(true);

  }
  const handleCalendarChange = (value: any, dateString: any) => {

    if (value === null) {
      setCheckbox([false, true])
    }
    if (value?.[1] !== null) {
      setOpen(false)
    } else {
      setClose(true)
    }
    if (dateString.length > 0) {
      setDate({
        startDate: dateString[0],
        endDate: dateString[1],
      });
      setOpen(false);
    }
    if (value?.[0] !== null && value?.[1] !== null) {
      setOpen(false);
    }
    (date.endDate != '' || date.startData != '') && setOpen(false);

  }

  const handleBlur = (elem: React.FocusEvent<HTMLInputElement>) => {
    const value = moment(elem.target.value);
    if (elem.target.value === '') {
      handleCalendarChange(null, elem.target.value);
      setCheckbox([false, true]);
      return;
    }
    if (value && value.isValid()) {
      setOpen(false);
    }
  }



  return (
    <div className="rangepicker">
      <div className="rangepicker-icon-left">
        <DateIcon />
      </div>
      <RangePicker
        className="custom-rangepicker"
        suffixIcon={<ArrowDown />}
        onCalendarChange={(value: any, dateString: any) => handleCalendarChange(value, dateString)}
        open={open}
        value={[date?.startDate ? moment(date?.startDate) : null, date.endDate ? moment(date?.endDate) : null]}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
      <div className="rangepicker-icon-right">
        <DateIcon />
      </div>
      <div className="rangepicker-checkbox">
        <Checkbox
          checked={checkbox[0]}
          onChange={(st) => setCheckbox([true, false])}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
